import React, { FC, memo } from 'react'
import SC from '../base/ProgressLine.styles'
import { IProgressLineProps } from '../types'
import { useLeftIndentPercent, useRightIndentPercent } from '../bll'

const { Block, Current } = SC

/** Линия прогресса */
const ProgressLine: FC<IProgressLineProps> = (props) => {
  const {
    currentMinValue = 0,
    currentMaxValue = 0,
    minValue = 0,
    maxValue = 100,
    height = '4px',
    color = 'blue',
    bgColor = 'gray9',
    ...otherProps
  } = props

  const rightIndentPercent = useRightIndentPercent({ maxValue, currentMaxValue })
  const leftIndentPercent = useLeftIndentPercent({ maxValue, minValue, currentMinValue })

  return (
    <Block height={height} color={bgColor} {...otherProps}>
      <Current
        color={color}
        height={height}
        left={leftIndentPercent}
        right={rightIndentPercent}
      />
    </Block>
  )
}

export { ProgressLine }
export default memo(ProgressLine)
